// import { Line } from '@/components/elements/Line'
import { NewsTagButton } from '@/components/elements/News/NewsTagButton'
import { Select } from '@/components/elements/Select'
import { AccordionFilter } from '@/components/enpages/News/AccordionFilter'
import { FilterField } from '@/components/pages/News/FilterField'

type Tag = {
  name: string
  filterId: string
  isActive: boolean
}

type Props = {
  tagList: readonly Tag[]
}

export const Filter = ({ tagList }: Props) => {
  return (
    <AccordionFilter>
      <div className="adjusted-margin">
        <FilterField title="Year">
          <Select
            id="irp-press-navi"
            name="focus"
            aria-label="掲載年"
            defaultValue=""
            options={[]}
          />
        </FilterField>
      </div>
      {/* 
        <Line color="grey" weight={1} direction="horizon" /> 
        下のdivで、FilterFieldを非表示にしているので、再表示したい時はdivを外してください。伊藤
      */}
      <div style={{display:"none"}}>
        <FilterField title="Tag">
          {tagList.map((tag) => (
            <NewsTagButton
              tag={tag}
              key={tag.name}
              isActive={tag.isActive}
              data-filter2={tag.filterId}
            />
          ))}
        </FilterField>
      </div>
    </AccordionFilter>
  )
}
